import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpPost } from "../../../app/common/utils/http";

// Define the async thunk for a POST request
export const sendingMessage = createAsyncThunk(
  "sendMessageSlice/sendingMessage",
  async (message, { rejectWithValue }) => {
    try {
      let channel = window.location.toString();
      if (window.top !== window.self){
          channel = document.referrer
      }
      let requestData = {
        messageID: message.messageID,
        sentMessage: message.messageText,
        sessionID: localStorage.getItem("sessionID"),
        messageType: message.messageType,
        isMenuItem: message.isMenuItem,
        functionType: message.functionType,
        functionMessageOrder: message.functionMessageOrder,
        noq: message.noq,
        channel: channel
      };
      
      // Replace '/your-endpoint' with your actual endpoint
      const response = await httpPost("AVAMessage/SendMessage", requestData);
      localStorage.setItem("sessionID", response.details[0].sessionID);
     
      
      // Map the entire list of response.details
      const responseData = response.details.map((detail, index) => ({
        message: detail.recievedMessage,
        messageID: message.itemsAmount + (index+2),
        messageType: detail.messageType,
        functionType: detail.functionType,
        functionMessageOrder: detail.functionMessageOrder,
        noq: detail.noq
      }));

      
      if ((window.top !== window.self) && (document.referrer == process.env.REACT_APP_API_URL_SELF_SERVICE_ORIGIN)){
        if(responseData[0].functionType == 'Callback'){
          localStorage.clear();
          window.parent.postMessage(
            { content: 'Callback' },
            process.env.REACT_APP_API_URL_SELF_SERVICE_ORIGIN
          );
          window.location.reload();
          
        }
      }
      
      return responseData; // Return the complete list
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const sendMessageSlice = createSlice({
  name: "sendMessageSlice",
  initialState: {
    avaMessages: [],
    loadingAVAMessages: false,
    errorAVAMessages: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendingMessage.pending, (state) => {
        state.loadingAVAMessages = true;
        state.errorAVAMessages = null;
      })
      .addCase(sendingMessage.fulfilled, (state, action) => {
        state.loadingAVAMessages = false;
        state.avaMessages = [...state.avaMessages, ...action.payload]; // Append all new messages
      })
      .addCase(sendingMessage.rejected, (state, action) => {
        state.loadingAVAMessages = false;
        state.errorAVAMessages = action.payload;
      });
  },
});

export default sendMessageSlice.reducer;
